module.exports = __webpack_public_path__ + "static/img/M-3.5b72399.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mgaofu/M-3.png
// module id = tXbT
// module chunks = 0